exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".fullscreen {\n    grid-area: fullscreen;\n}", ""]);

